import { useMemo } from "react"
import { useAEMContent } from "@AEM/AEMContentLoader"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { AEMIcons } from "@AEM/models/AEMIcons"
import { AEMSvgData } from "@components/AEMSvg"

type IconDictionary = Record<string, AEMSvgData>

export const useAEMIcons = () => {
	const {
		data: iconsContent,
		isLoading,
		error
	} = useAEMContent(AEMPageType.ICONS)
	const iconsData = (iconsContent as AEMIcons)?.icons || []

	const iconsDictionary = useMemo(() => {
		const dictionary: IconDictionary = {}

		if (iconsData && iconsData.length > 0) {
			for (const icon of iconsData) {
				dictionary[icon.fileName] = {
					path: icon.dynamicMediaUrl,
					title: icon.fileName,
					iconSvg: icon.icon
				}
			}
		}

		return dictionary
	}, [iconsData])

	const getIcons = (fileNames: string | string[]) => {
		if (!fileNames) iconsDictionary

		const iconNames = Array.isArray(fileNames) ? fileNames : [fileNames]
		const filteredDictionary: IconDictionary = {}
		for (const name of iconNames) {
			if (iconsDictionary[name]) {
				filteredDictionary[name] = iconsDictionary[name]
			}
		}

		return filteredDictionary
	}

	return {
		icons: iconsDictionary,
		isLoading,
		error,
		getIcons
	}
}
